(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-popup"] && !window.DesignMode) return;
  try {
    
let modal = document.querySelector('.l_modal');
let CloseBtn = document.querySelector('.l_modal-close');
let overlay = document.querySelector('.l_modal_overlay');

CloseBtn.addEventListener('click', function(){
  modal.classList.add('active');
  overlay.classList.add('active');
});

var currentDate = new Date(); 
var currentDateString = currentDate.toISOString(); 
Shopify.theme.currentDate = currentDateString;

  } catch(e) { console.error(e); }
})();
})();
